import { HStack } from "@chakra-ui/layout";
import { Button } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { ActionsColumn } from "@src/components/modules/bank/components/columns";
import {
  ACTIONS_COLUMN_ID,
  DataTable,
  LoadingOverlay,
} from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { Pagination } from "@src/components/ui-kit/table/pagination";
import { FiltersPanel } from "@src/utils/components/filters/components/filters-panel";
import { useStore } from "@src/utils/hooks";
import { observer, useLocalObservable } from "mobx-react-lite";
import { createContext } from "react";
import { AddManualMoveModal } from "./add-manual-move-modal";
import { AddManualMoveModalStore } from "./add-manual-move-modal/store";
import { MatchPaymentModal } from "./match-payment-modal";
import { BankMatchPaymentModalStore } from "./match-payment-modal/store";
import { BankStore } from "./stores";

export const BankListStoreContext = createContext<BankStore>(
  null as unknown as BankStore,
);

export const BankList = observer(function BankList() {
  const appStore = useStore();
  const { store, columns } = useLocalObservable(() => ({
    store: new BankStore(
      appStore,
      new BankMatchPaymentModalStore(appStore),
      new AddManualMoveModalStore(appStore),
    ),
    columns: createColumns(),
  }));

  return (
    <BankListStoreContext.Provider value={store}>
      <DataTable>
        <DataTable.NavBar>
          <HStack py="4" px="2" alignItems="start">
            <FiltersPanel filters={store.where} onSearch={store.setSearch} />
            <Button
              colorScheme="grey"
              leftIcon={<Icon name="plus" />}
              onClick={store.addManualMoveModalStore.disclosure.onOpen}
              variant="outline"
            >
              <Trans>Add bank move manually</Trans>
            </Button>
          </HStack>
        </DataTable.NavBar>

        <LoadingOverlay
          isLoading={store.fetcher.isLoading.value}
          position="absolute"
        >
          <DataTable.Body
            columns={columns}
            data={store.tableData}
            tableKey={store.tableKey}
          />
        </LoadingOverlay>

        <Pagination store={store.pagination} />
      </DataTable>

      <MatchPaymentModal />

      <AddManualMoveModal />
    </BankListStoreContext.Provider>
  );
});

function createColumns() {
  const columns = BankStore.getColumnsWithoutActions();

  columns.push({
    id: ACTIONS_COLUMN_ID,
    meta: { label: t`Actions` },
    header: () => t`Actions`,
    size: 200,
    cell: ({ row }) => <ActionsColumn accountMove={row.original} />,
  });

  return columns;
}
